angular.module('rjmNg.services').factory '$url', [
  "appParams"
  "siteRoot"
  (
    appParams
    siteRoot
  ) ->
    (url) ->

      # Cache bust html templates based on the latest deploy
      _cacheBustHtml = (url) ->
        if url.match /\.html/
          url = "#{url}?bust=#{appParams.cacheBustId}"
        return url

      # Cache bust html templates
      url = _cacheBustHtml(url)
      return "#{siteRoot}/v2#{url}"
]
